import {Button, ButtonGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDateRange} from "../contexts/DateRangeProvider";
import useTranslation from "../hooks/translations";
import useMonths from "../hooks/months";

export default function MonthNavigator() {
  const months = useMonths();
  const translations = useTranslation();
  const {
    year,
    month,
    goToPreviousMonth,
    goToNextMonth,
    goToCurrentMonth,
    isCurrentMonth
  } = useDateRange();

  return (
    <>
      <div className="p-2">
        <ButtonGroup className="me-2" aria-label="Month navigation group">
          <Button variant="outline-primary" onClick={goToPreviousMonth}>
            <FontAwesomeIcon icon="arrow-left"/>
          </Button>
          <Button variant="outline-primary" onClick={goToCurrentMonth}
                  disabled={isCurrentMonth}>
            {translations.currentMonth}
          </Button>
          <Button variant="outline-primary" onClick={goToNextMonth}>
            <FontAwesomeIcon icon="arrow-right"/>
          </Button>
        </ButtonGroup>
        {months[month]}, {year}
      </div>
    </>
  );
}
